import { FormPalette, Theme } from './types';

export const getFormPalette = (theme: Theme, palette?: FormPalette) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return theme.palette.form[palette || 'default'];
};
